// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M2 2H14V9.0202L22 10.6869V22H16V16H14V22H2V2ZM8 7.7702L12 8.60353V4H4V20H8V7.7702Z"}}]};

const City15FilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'city-15-filled',
    ref,
    icon: element,
  },
));

City15FilledIcon.displayName = 'City15FilledIcon';

export default City15FilledIcon;
